<template>
  <div class='home'>
    <OrganizationList
      v-show='listView'
      @newOrganization='onClickNewFromList'
      @editOrganization='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <OrganizationForm
      v-show='formView'
      :organization='organization'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import OrganizationList from '@/components/organization/OrganizationList.vue'
import OrganizationForm from '@/components/organization/OrganizationForm.vue'

export default {
  name: 'Organization',
  components: {
    OrganizationList,
    OrganizationForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      organization: {
        id: null,
        name: null,
        address: null,
        email: null,
        phone: null,
        logo: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      console.log(value)
      this.organization = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.organization = {
        id: null,
        name: null,
        address: null,
        email: null,
        phone: null,
        logo: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.organization = {
        id: null,
        name: null,
        address: null,
        email: null,
        phone: null,
        logo: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {}
}
</script>
